<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:40px;">Acknowledgement</h1>
<p>I had written this book around 2011 and left it to sit on my hard drive because I thought it does not have the required value to be considered for printing. However, if it wasn’t for the stubborn insistence of my two friends, Laurie Buckland and Leon Prince, who assured me that this book should be out for general use and with their firm support, I have made this crucial step. I am therefore very grateful for all your support and encouragement you have given me in the very early stages because without you, I wouldn’t have had the courage to do what I did. Many thanks for everything.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?89aa37f0